<div class="login-form">
  <form [formGroup]="loginForm" (keyup.enter)="login()">
    <div class="inputs">
      <mat-form-field>
        <input matInput placeholder="Email" formControlName="email" required />
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Passwort" type="password" formControlName="password" required />
      </mat-form-field>
    </div>
  </form>
  <p>Noch keinen Account? Klicke <a [routerLink]="['/register']">hier</a>.</p>
  <div class="buttons">
    <button mat-raised-button type="reset" (click)="reset()" [disabled]="busy">
      Abbrechen
    </button>
    <button mat-raised-button type="submit" color="primary" (click)="login()" [disabled]="busy">
      Login
    </button>
  </div>
</div>
